import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = (props) => {
  return <Spinner className="txt-blue" {...props}  />;
};

export default Loader;
